export default __webpack_public_path__ + "static/media/sort_white.5c73199e.svg";